import React, { useEffect, useCallback, useState} from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {connect} from 'react-redux';

const AutoMapSettings = ({effect}) => { 
    const [randomness, setRandomness] = useState(effect.randomness);

    const onChange = useCallback((e) => {
        let v = e.target.value;
        effect.randomness = v;
        setRandomness(v);
    }, [setRandomness]);

    return (
        <div className="auto-map-settings">
          <div className="randomness">
            Randomness: {randomness}
          </div>
          <ReactBootstrapSlider
            value={randomness}
            change={onChange}
            step={0.1}
            max={100}
            min={0}
            orientation="horizontal"
            reversed={false}
          />
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoMapSettings);
